export class ActivityTopic {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.name = form.name;
      this.status = form.status;
      this.subtitle = form.subtitle;
      this.beginTime = form.beginTime;
      this.endTime = form.endTime;
      this.time = form.time;
      this.uaEventCityId = form.uaEventCityId;
      this.otherAddress = form.otherAddress;
      this.address = form.address;
      this.linkTo = form.linkTo;
      this.ActivityImageVO = form.ActivityImageVO;
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = "";
    this.name = "";
    this.status = "";
    this.subtitle = "";
    this.beginTime = "";
    this.endTime = "";
    this.time = "";
    this.uaEventCityId = "";
    this.otherAddress = "";
    this.address = "";
    this.linkTo = "";
    this.ActivityImageVO = "";
  }
}
